<main>
  <ng-container *ngIf="customLoad.length == 0 ||customLoad == 'dev'">
    <div>


      <mat-form-field appearance="fill">
        <mat-label>Selectionner une borne</mat-label>
        <mat-select disableRipple (selectionChange)="onSelectDevice($event.value)">
          <mat-option *ngFor="let device of deviceList" [value]="device.id">
            {{device.data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <div class="table-wrapper">


      <table *ngIf="displayData.length > 0" mat-table [dataSource]="displayData" class="mat-elevation-z8">

        <!-- Date Column -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let element"> {{element.createdAt.seconds*1000 | date: 'dd MMMM yyyy HH:mm:ss'}} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let element"> {{element.type |translation}} </td>
        </ng-container>



        <!-- LMediaData Column -->
        <ng-container matColumnDef="mediaData">
          <th mat-header-cell *matHeaderCellDef>Informations </th>
          <td mat-cell *matCellDef="let element" (click)="showMediaData(element.mediaData, element.type)"> <mat-icon>info</mat-icon> </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="diplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: diplayedColumns;"></tr>
      </table>
    </div>
  </ng-container>
  <ng-container *ngIf="customLoad == 'malta' || customLoad == 'dev'">
    <app-ordermalta></app-ordermalta>
  </ng-container>
</main>
